"use client";

import React from "react";
import { SWRConfig } from "swr";
import "@marginly/ui/styles/fonts.css";
import "@marginly/ui/styles/theme.css";
import "@marginly/ui/styles/reset.css";

import type { onWalletConnect, onWalletDisconnect } from "actions/wallet";
import { RxProvider } from "contexts/rx";
import { Web3Provider } from "contexts/web3";
import { AppConfig } from "types/common";
import Errors from "./notifications";

const Provider: React.FC<{
  // TODO remove any
  children: any;
  config: AppConfig;
  onWalletConnect?: typeof onWalletConnect;
  onWalletDisconnect?: typeof onWalletDisconnect;
}> = ({ children, config, onWalletConnect, onWalletDisconnect }) => {
  return (
    <Web3Provider
      projectId={config.projectId}
      chains={config.chains}
      poolConfig={config.pools}
      onWalletConnect={onWalletConnect}
      onWalletDisconnect={onWalletDisconnect}
    >
      <RxProvider>
        <Errors />
        <SWRConfig
          value={{
            shouldRetryOnError: false,
            // revalidateOnMount: false,
            // revalidateIfStale: false,
            // keepPreviousData: true,
            // provider: () => new Map(),
          }}
        >
          {children}
        </SWRConfig>
      </RxProvider>
    </Web3Provider>
  );
};

export default Provider;
